import { render, staticRenderFns } from "./TruncatedTextDisplay.vue?vue&type=template&id=2bbee5c0&scoped=true"
import script from "./TruncatedTextDisplay.vue?vue&type=script&lang=js"
export * from "./TruncatedTextDisplay.vue?vue&type=script&lang=js"
import style0 from "./TruncatedTextDisplay.vue?vue&type=style&index=0&id=2bbee5c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbee5c0",
  null
  
)

export default component.exports